/**
 * 环境变量配置
 *
 * 这个文件导出所有环境变量，供应用使用
 * REACT_APP_ 开头的变量会在部署时被后端脚本替换为实际值
 */

export const REACT_APP_API_BASE_URL = process.env.ENV_REPLACE_REACT_APP_API_BASE_URL
export const REACT_APP_IMAGE_BASE_URL = process.env.ENV_REPLACE_REACT_APP_IMAGE_BASE_URL
export const REACT_APP_ENV = process.env.ENV_REPLACE_REACT_APP_ENV
export const REACT_APP_OAUTH_URL = process.env.ENV_REPLACE_REACT_APP_OAUTH_URL
